import { useEffect, useState } from "react";

import { BreakpointSize, getResponsiveBreakpoint } from "./responsiveBreakpoints";

const MOBILE_SIZES: BreakpointSize[] = ["xs", "sm"];

const checkIsMobile = () => MOBILE_SIZES.includes(getResponsiveBreakpoint());

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(checkIsMobile());

  useEffect(() => {
    const handleResize = () => setIsMobile(checkIsMobile());

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
